export default __webpack_public_path__ + "static/media/img12.2d5f219e.png";